<div class="container">

    <div *ngIf="role==1; then adminActive">
    </div>

    <ng-template #adminActive>
        <div *ngFor="let user of candidates">
            <div class="card" *ngFor="let candidate of user.candidates let i = index">
                <mat-card *ngIf="candidate.username.split('-')[1]==''">
                    <mat-card-header>
                        <mat-card-title>{{candidate.name}} {{candidate.lastname}}</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div>
                            <p><span>Usuario </span>{{candidate.username}}</p>
                            <p><span>Contraseña </span>{{candidate.password}}</p>
                            <div *ngIf="candidate.status==true then active else inactive">
                            </div>
    
                            <ng-template #active>
                                <p><span>Estatus de aplicación </span> <a (click)="activateUser(candidate)" href="javascript:void(0)">Activo</a> </p>
                            </ng-template>
                            <ng-template #inactive>
                                <p><span>Estatus de aplicación </span> <a (click)="activateUser(candidate)" href="javascript:void(0)">Inactivo</a> </p>
                            </ng-template>
    
                        </div>
                        <div>
    
                        </div>
    
    
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
      </ng-template>

    <div *ngIf="role==1; then admin else recruiter">
    </div>

<!--    <div *ngFor="let user of candidates">
        <div class="card" *ngFor="let candidate of user.candidates let i = index">
            <mat-card>
                <mat-card-header>
                    <mat-card-title>{{candidate.name}} {{candidate.lastname}}</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div>
                        <p><span>Usuario </span>{{candidate.username}}{{candidate.username.split('B')}}</p>
                        <p><span>Contraseña </span>{{candidate.password}}</p>
                        <div *ngIf="candidate.status==true then active else inactive">
                        </div>

                        <ng-template #active>
                            <p><span>Estatus de aplicación </span> Activo</p>
                        </ng-template>
                        <ng-template #inactive>
                            <p><span>Estatus de aplicación </span> Inactivo</p>
                        </ng-template>

                    </div>
                    <div>

                    </div>


                </mat-card-content>
            </mat-card>
        </div>
    </div> -->

    <ng-template #admin>
        <div *ngFor="let user of candidates">
            <div class="card" *ngFor="let candidate of user.candidates let i = index">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title>{{candidate.name}} {{candidate.lastname}}</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div>
                            <p><span>Usuario </span>{{candidate.username}}</p>
                            <p><span>Contraseña </span>{{candidate.password}}</p>
                            <div *ngIf="candidate.status==true then active else inactive">
                            </div>
    
                            <ng-template #active>
                                <p><span>Estatus de aplicación </span> Activo</p>
                            </ng-template>
                            <ng-template #inactive>
                                <p><span>Estatus de aplicación </span> Inactivo</p>
                            </ng-template>
    
                        </div>
                        <div>
    
                        </div>
    
    
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
      </ng-template>

      <ng-template #recruiter>
        <div class="card" *ngFor="let candidate of candidates let i = index">
            <mat-card>
                <mat-card-header>
                    <mat-card-title>{{candidate.name}} {{candidate.lastname}}</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div>
                        <p><span>Usuario </span>{{candidate.username}}</p>
                        <p><span>Contraseña </span>{{candidate.password}}</p>
                        <div *ngIf="candidate.status==true then active else inactive">
                        </div>

                        <ng-template #active>
                            <p><span>Estatus de aplicación </span> Activo</p>
                        </ng-template>
                        <ng-template #inactive>
                            <p><span>Estatus de aplicación </span> Inactivo</p>
                        </ng-template>

                    </div>
                    <div>

                    </div>


                </mat-card-content>
            </mat-card>
        </div>
      </ng-template>


    <button class="savebutton" mat-fab color="accent" (click)="newCandidate()">
        <mat-icon>add</mat-icon>
    </button>
</div>